<label class="search" for="search">
  <input class="search__input" name="search" type="text" placeholder="Поиск">
</label>

